import type { CSSProperties } from "react";

// Publisher names and brand tokens are independent of serving infrastructure.
const PUBLISHERS: Record<string, [label: string, palette: string]> = {
  "anthracite-org": ["Anthracite", "neutral"],
  "bytedance": ["ByteDance", "bytedance"],
  "cognitivecomputations": ["Cognitive Computations", "neutral"],
  "deepseek": ["DeepSeek", "deepseek"],
  "deepseek-ai": ["DeepSeek", "deepseek"],
  "google": ["Google", "google"],
  "ibm-granite": ["IBM", "ibm-granite"],
  "inclusionai": ["inclusionAI", "inclusionai"],
  "meituan": ["Meituan", "meituan"],
  "meta": ["Meta", "meta"],
  "meta-llama": ["Meta", "meta"],
  "microsoft": ["Microsoft", "microsoft"],
  "minimax": ["MiniMax", "minimax"],
  "mistralai": ["Mistral AI", "mistralai"],
  "moonshotai": ["Moonshot AI", "neutral"],
  "nex-agi": ["Nex AGI", "neutral"],
  "nousresearch": ["Nous Research", "neutral"],
  "nvidia": ["NVIDIA", "nvidia"],
  "openai": ["OpenAI", "neutral"],
  "poolside": ["Poolside", "poolside"],
  "prism-ml": ["PrismML", "neutral"],
  "qwen": ["Alibaba · Qwen", "qwen"],
  "rekaai": ["Reka AI", "neutral"],
  "sao10k": ["Sao10K", "sao10k"],
  "stepfun": ["StepFun", "stepfun"],
  "tencent": ["Tencent", "tencent"],
  "thinkingmachines": ["Thinking Machines", "neutral"],
  "trinity": ["Arcee AI", "trinity"],
  "xiaomi": ["Xiaomi", "neutral"],
  "z-ai": ["Z.ai", "neutral"],
  "zai-org": ["Z.ai", "neutral"],
  "nodus": ["Nodus", "nodus"],
};

export function modelPublisher(id: string) {
  const namespace = (id.split("/")[0] ?? "unknown").toLowerCase();
  const [label, palette] = PUBLISHERS[namespace] ?? [namespace, "neutral"];
  return { label, style: {
    "--publisher-accent": `var(--nd-publisher-${palette}-accent)`,
    "--publisher-light": `var(--nd-publisher-${palette}-light)`,
    "--publisher-dark": `var(--nd-publisher-${palette}-dark)`,
    ...(namespace === "google" ? { "--publisher-stripe": "var(--nd-publisher-google-stripe)" } : {}),
  } as CSSProperties };
}
